export default "__VITE_ASSET__CHRRHKwM__"